"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteOfferItemHandler = deleteOfferItemHandler;
var _deleteOfferItemFailed = require("@ori-events/delete-offer-item-failed");
var _checkoutUtils = require("@ori/checkout-utils");
var _api = require("../api");
var _logger = require("../logger");
var _types = require("../types");
var _utils = require("../utils");
const dispatchErrorEvent = detail => {
  const errorEvent = new CustomEvent(_deleteOfferItemFailed.Name, {
    detail
  });
  window.dispatchEvent(errorEvent);
};
async function deleteOfferItemHandler({
  detail: {
    choiceId,
    itemCode
  }
}, {
  client,
  sessionId,
  tenant
}) {
  // STEP 1 - Update through API
  try {
    await (0, _api.deleteOfferItem)({
      client,
      itemCode,
      offerId: choiceId,
      sessionId,
      tenant
    });
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while deleting offer item in delete-offer-item event.'
    });
    dispatchErrorEvent({
      isSuccess: false,
      localizedMessage: '',
      message: 'Deletion of offer item failed via API call'
    });
    return false;
  }

  // STEP 2 - Update shopping context via Online endpoint
  const response = await fetch(_types.RequestUrl.GetShoppingContext, (0, _utils.getHttpRequestSettings)(undefined, _checkoutUtils.HttpMethod.Post));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if ((0, _deleteOfferItemFailed.isDeleteOfferItemErrorResponse)(data)) {
    dispatchErrorEvent(data);
    return false;
  }
  return data;
}
//# sourceMappingURL=deleteOfferItemHandler.js.map